import type { State } from '@user/components/Referrals/state'
import { IReferral } from '@sales-center/common'

export function referralDataMapperModelToDTO(referralModel: State): IReferral {
  const referralType = referralModel.referralType
  const referral: IReferral = {
    ...referralModel,
    referralSource: '',
    referralType: referralType ?? 'None',
    referralValue: '',
  }
  if (referralType !== 'Customer') {
    referral.referralDiscountCode = ''
    referral.referralDiscountId = ''
    referral.referralDiscountType = undefined
    referral.referralDiscountValue = 0
  }
  switch (referralType) {
    case 'Customer':
      referral.referralValue = referralModel.referralCustomerId
      referral.referralEmployeeId = null
      break
    case 'Employee':
      referral.referralValue = referralModel.referralEmployeeValue || ''
      referral.referralEmployeeId = referralModel.referralEmployeeId || ''
      break
    case 'Other':
      referral.referralValue = referralModel.referralOther
      referral.referralEmployeeId = null
      break
    case 'None':
      referral.referralValue = 'No Referral'
      referral.referralEmployeeId = null
      break
  }
  return referral
}

export function initReferralDataModel(): IReferral {
  return {
    referralSource: '',
    referralType: 'None',
    referralValue: '',
    referralEmployeeId: null,
    referralDiscountCode: '',
    referralDiscountId: '',
    referralLocationCode: '',
    referralDiscountType: undefined,
    referralDiscountValue: 0,
  }
}
